/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_CreditInputs */

const en_gc_editor_credit = /** @type {(inputs: Gc_Editor_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official open-source editor by ArtCraft · Independent guide by gridcraft.me`)
};

const zh_gc_editor_credit = /** @type {(inputs: Gc_Editor_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft 官方开源编辑器 · gridcraft.me 独立指南`)
};

/**
* | output |
* | --- |
* | "Official open-source editor by ArtCraft · Independent guide by gridcraft.me" |
*
* @param {Gc_Editor_CreditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_credit = /** @type {((inputs?: Gc_Editor_CreditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_CreditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_credit(inputs)
	return zh_gc_editor_credit(inputs)
});
export { gc_editor_credit as "gc.editor.credit" }